import {Component, Injector} from '@angular/core';
import {ApiContext, EnvironmentService, PesFormModel, PesLoginComponent} from '@pes/ui';
import {PES_LOGIN_MODEL} from './login.model';

/**
 * PesLoginComponent allows users to authenticate them on the application.
 */
@Component({
    selector: 'pes-login',
    templateUrl: 'login.component.html'
})
export class LoginComponent extends PesLoginComponent {

    public readonly config: PesFormModel = PES_LOGIN_MODEL;

    constructor(private readonly injector: Injector, private readonly _env: EnvironmentService, private readonly _context: ApiContext) {
        super(injector);
    }

    private connectSso(): void {
        if (this._env.isProd()) {
            window.location.href = `${this._context.baseUrl}/saml/login/alias/lbpas-8b0b7a75-a30e-4440-9938-ff79a2acfb3c?idp=https://auth1.secure.sf.intra.laposte.fr`;
        } else if (this._env.isPreProd()) {
            window.location.href = `${this._context.baseUrl}/saml/login/alias/lbpas-8b0b7a75-a30e-4440-9938-ff79a2acfb3c?idp=https://auth1-recette.secure.sf.intra.laposte.fr`;
        } else if (this._env.isLocal()) {
            window.location.href = `${this._context.baseUrl}/saml/login/alias/lbpas-8b0b7a75-a30e-4440-9938-ff79a2acfb3c?idp=com:docaposte:pes:idp5`;
        } else {
            window.location.href = `${this._context.baseUrl}/saml/login/alias/lbpas-8b0b7a75-a30e-4440-9938-ff79a2acfb3c?idp=https://auth1-recette.secure.sf.intra.laposte.fr`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/component/pes-login/login.component.ts